import SmartSearchAndActionsLayout from "../../../components/Layouts/smart-search-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import { getReport } from "../../../services/reports";
import endpoints from "../../../utils/endpoints";

function LocationList() {
  return (
    <SmartSearchAndActionsLayout
      searchBy={[
        SearchOptionEnum.DISTRIBUTOR,
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      labels={["active", "closed", "inactive"]}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      onRefresh={(output, params) => {
        const getReportParams: Record<string, string> = {
          output,
            name: "Location List",
        };

        if (params.id) {
          getReportParams[`${params.type}Id`] = params.id;
        }
        return getReport(
          getReportParams,
          endpoints.getLocationListReport,
          output
        );
      }}
    />
  );
}

export default LocationList;
